/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsteppages3Inputs */

const en_placewebsteppages3 = /** @type {(inputs: Placewebsteppages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for contact details and opening hours`)
};

const de_placewebsteppages3 = /** @type {(inputs: Placewebsteppages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt und Öffnungszeiten suchen`)
};

/**
* | output |
* | --- |
* | "Looking for contact details and opening hours" |
*
* @param {Placewebsteppages3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsteppages3 = /** @type {((inputs?: Placewebsteppages3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsteppages3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsteppages3(inputs)
	return de_placewebsteppages3(inputs)
});
export { placewebsteppages3 as "placeWebStepPages" }